export interface RgbColor {
	r: number;
	g: number;
	b: number;
}

/**
 * Конверт строки вида AABBCC (#AABBCC) в RgbColor
 */
export const hexToRgb = (hex: string): RgbColor => {
	if (hex[0] === '#') {
		hex = hex.substring(1);
	}

	const rgb = (i: number) => parseInt(hex.substring(i * 2, (i + 1) * 2), 16);

	return {
		r: rgb(0),
		g: rgb(1),
		b: rgb(2),
	};
};

/**
 * Конверт RgbColor в строку вида AABBCC
 */
export const rgbToHex = (color: RgbColor): string => {
	const hex = (n: number) => n.toString(16).padStart(2, '0');
	return `${hex(color.r)}${hex(color.g)}${hex(color.b)}`;
};
